import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n";
import frFlag from "../assets/lang/fr.png";
import enFlag from "../assets/lang/en.png";
import arFlag from "../assets/lang/ar.png";

const LANGUAGE_FLAGS = {
  fr: frFlag,
  en: enFlag,
  ar: arFlag,
};

const LanguageSwitcher = ({ color = "inherit" }) => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const changeLanguage = (lng) => {
    void i18n.changeLanguage(lng);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color }}
        aria-label={t("language.label")}
      >
        <TranslateIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <MenuItem
            key={lng}
            selected={i18n.language.startsWith(lng)}
            onClick={() => changeLanguage(lng)}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                component="img"
                src={LANGUAGE_FLAGS[lng]}
                alt=""
                sx={{
                  width: 20,
                  height: 20,
                  objectFit: "cover",
                  borderRadius: "3px",
                  flexShrink: 0,
                }}
              />
              <Typography>{t(`language.${lng}`)}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
